<template>
  <div class="text-static-default-hi body-2-bold">
    <div class="mb-8 grid grid-cols-1 gap-8 md:grid-cols-2">
      <div class="flex flex-col gap-8">
        <ItemDeliveryDate :shipping />
        <ItemReassurance class="min-h-[40px]" :tracking :warranty-delay />
      </div>
      <div class="flex flex-col gap-8">
        <ItemCarrier
          v-if="shouldDisplayCarriers"
          :tracking="{
            zone: 'carrier_compatibility',
            name: 'carrier_info',
          }"
        />
        <ItemCustomerSupport class="min-h-[40px]" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'

import { ProductCategory } from '~/scopes/product/constants'
import ItemCarrier from '~/scopes/product/pages/Product-JP/components/ReassuranceItems/components/ItemCarrier/ItemCarrier.vue'
import ItemCustomerSupport from '~/scopes/product/pages/Product-JP/components/ReassuranceItems/components/ItemCustomerSupport/ItemCustomerSupport.vue'
import ItemDeliveryDate from '~/scopes/product/pages/Product-JP/components/ReassuranceItems/components/ItemDeliveryDate/ItemDeliveryDate.vue'

import ItemReassurance from './components/ItemReassurance/ItemReassurance.vue'

const props = withDefaults(
  defineProps<{
    shipping: NonNullable<GetPickersResponse['selectedOffer']>['shipping']
    categoryId: string
    warrantyDelay?: string | null
  }>(),
  {
    warrantyDelay: undefined,
  },
)

const tracking = computed(() => {
  return { zone: 'return_info', name: '30_days_return' }
})

const shouldDisplayCarriers = computed(
  () => props.categoryId === ProductCategory.SMARTPHONE,
)
</script>
